import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@Sage/hoi-poi-ui';
import { t } from 'utils/getLiteral';
import './styles.scss';

/**
 * General component description.
 */

const ImplementationsModal = memo(({ isOpen, closeModal = () => null, onAfterClose, children }) => {
    return (
        <Modal
            width={1000}
            // A definite height is what keeps the grid as the only scrollable area: without it
            // the modal shrink-wraps its content and the body starts scrolling on short viewports.
            height="min(680px, calc(100vh - 40px))"
            title={t('cfm_label_choose_implementation')}
            className="implementations-modal"
            classes={{ content: `implementations-modal-body` }}
            overlayClassName={'implementations-modal-overlay'}
            isOpen={isOpen}
            onRequestClose={closeModal}
            onAfterClose={onAfterClose}
        >
            {children}
        </Modal>
    );
});

ImplementationsModal.propTypes = {
    /** Description of prop "children". */
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    /** Indicate if modal is opened */
    isOpen: PropTypes.bool,
    /** Function to call when close modal */
    closeModal: PropTypes.func,
    /** Function to call once the closing transition has finished */
    onAfterClose: PropTypes.func,
};

export default ImplementationsModal;
